import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Clipboard from 'v-clipboard'
import KeepRatio from 'vue-keep-ratio'
import VueI18n from 'vue-i18n'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18nMsg from '@/i18n'

import './debug'

Vue.config.productionTip = false

axios.defaults.crossDomain = true
axios.defaults.withCredentials = true

Vue.use(Clipboard)
Vue.use(ElementUI)
Vue.use(VueAxios, axios)
Vue.use(KeepRatio)
Vue.use(VueI18n)

new Vue({
  i18n: new VueI18n({ locale: 'zh-CN', messages: i18nMsg }),
  router,
  store,
  render: h => h(App),
}).$mount('#app')
